import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from 'hooks/shared/error';
import { layerNodesKeys } from './queryKeys';
import type { LayerNodeDto, DeleteLayerNodeBody } from './types';

export function useDeleteLayerNodeMutation() {
  const queryClient = useQueryClient();

  return useMutation<LayerNodeDto, unknown, DeleteLayerNodeBody>({
    mutationFn: async ({ id, groupGuid }: DeleteLayerNodeBody) => {
      const resp = await axios.delete<LayerNodeDto>(
        `${config.apiGateway.layer_nodes}/${id}`,
        { data: { groupGuid } }
      );
      return resp.data;
    },
    onSuccess: () => {
      toast.success('Layer category removed');
      queryClient.invalidateQueries({
        queryKey: layerNodesKeys.all(),
      });
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
